module.exports = "/static/assets/e34dcf9a3e10ded30209b07f84db139c.gif";